import {css} from "styled-components";
import {getColor} from "@/pipes/theme.pipe";

export const variantOptions = {
    standard: css`
        background-color: ${getColor('natural')};
        
        &:hover {
            background-color: ${getColor('natural')} !important;
        }
    `,
    convex: css`
        background: ${getColor('natural', '600')};
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 7%);
    `
}

export const getVariantStyles = ({variant}) => variantOptions[variant] ?? variantOptions['standard']
